import React, {useCallback, useState} from "react";
import Layout from "../layout/Layout";
import {ClientSelectSingle} from "../../../components/form-v2/searchable-select/ClientSelect";
import {Client} from "../../../types/userManagement";
import BasicText from "../../../components/form-v2/basic-text";
import {BlueButton} from "../../../components/ui/Buttons";
import {useNavigate} from "react-router-dom";
import {useUserManagementBrowsing} from "../../../lib/user-management/UserManagementBrowsingContext";
import {PhoneInput} from "../../../components/form-v2/phone-input/PhoneInput";
import {ToggleButton} from "../import/inputs";
import {useCreateDepartment} from "../../../api/platform/useDepartments";
import {ErrorBox} from "../../../components/ui/ErrorBox";



const DepartmentCreate: React.FC = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [receiveEmailNotifications, setReceiveEmailNotifications] = useState(false);
    const [client, setClient] = useState<Client>();

    const ctx = useUserManagementBrowsing();
    const clientID = ctx.clientID;
    const navigate = useNavigate();

    const createMutation = useCreateDepartment();

    const save = useCallback(() => {
        createMutation.mutate(
            { name, email, phone, receiveEmailNotifications, clientID },
            {
                onSuccess: () => {
                    const params = new URLSearchParams();
                    params.set("message", "department has been created");
                    navigate(`/management/departments?${params.toString()}`);
                },
            },
        );
    }, [name, email, phone, receiveEmailNotifications, clientID]);

    const fieldErrors = createMutation.error?.errors;

    return <Layout
        active={"departments"}
    >
            <div className="flex flex-col gap-8">
                <div className="bg-white shadow-md p-4 w-1/2 flex flex-col gap-8">
                    <p className="text-md text-left pb-2 font-semibold">Create Department</p>
                    {clientID && <ClientSelectSingle disabled={true} initialClientID={clientID} client={client} onChange={setClient}/>}
                    <div className="flex flex-col gap-1">
                        <BasicText value={name} onChange={setName} label="Name" />
                        {fieldErrors?.name?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                    </div>
                    <div className="flex flex-col gap-1">
                        <BasicText value={email} onChange={setEmail} label="Email" />
                        {fieldErrors?.email?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                    </div>
                    <ToggleButton text={"Receive Email Notifications"} initialValue={false} onChange={setReceiveEmailNotifications} />
                    <div className="flex flex-col gap-1">
                        <PhoneInput initialValue={phone} onChange={setPhone} label="Phone Number" />
                        {fieldErrors?.phone?.map((e, i) => <p key={i} className="text-red text-sm">{e}</p>)}
                    </div>
                    <BlueButton text={"Create Department"} disabled={name === ""} onClick={save} loading={createMutation.isLoading}/>
                    <ErrorBox error={createMutation.error} />
                </div>
            </div>

    </Layout>

}

DepartmentCreate.displayName = "DepartmentCreate";

export default DepartmentCreate;